export default __webpack_public_path__ + "static/media/BEL2017_Coastal_SWATCH_HollandStone_Knightsbridge.2739fd57.jpg";